import PageV2Comp from "../../components/page_v2/page_v2_comp";
import { ForgotPasswordContextProvider } from "./context/forgot_password_context";
import ForgotPasswordComp from "./components/forgot_password_comp";
const ForgotPasswordPage = () => {
    return (
        <PageV2Comp hideFooter={true}>
            <ForgotPasswordContextProvider >
                <ForgotPasswordComp />
            </ForgotPasswordContextProvider>
        </PageV2Comp>
    )
}

export default ForgotPasswordPage;